var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vector",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    fillOpacity: 0.38,
    d: "m404.09,51.74c-24.42,-9.46 -22.85,112.61 20.63,109.41 43.49,-3.19 49.27,-82.32 -20.63,-109.41Z",
    strokeOpacity: 0.38,
    strokeWidth: 0,
    id: "path_0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    fillOpacity: 0.38,
    d: "m277.57,43.33c-67.37,-13.68 -107.6,38.39 -128.49,81.21 -20.89,42.82 -41.61,84.69 -62.97,109.74 -21.36,25.05 -41.37,74.75 0,127.96s104.39,35.45 153.63,16.85c49.24,-18.6 100.16,24.95 150.42,4.99s105.87,-101.44 46.7,-160.15c-59.17,-58.7 -46.98,-157.79 -159.29,-180.6Z",
    strokeOpacity: 0.38,
    strokeWidth: 0,
    id: "path_1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    fillOpacity: 0.38,
    d: "M37.63,454.71a208.51,4.18 0,1 0,417.03 0a208.51,4.18 0,1 0,-417.03 0z",
    strokeOpacity: 0.38,
    strokeWidth: 0,
    id: "path_2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0ebff",
    d: "M338.57,330.76L352.52,330.76A0.46,0.46 0,0 1,352.98 331.21L352.98,333.5A0.46,0.46 0,0 1,352.52 333.95L338.57,333.95A0.46,0.46 0,0 1,338.11 333.5L338.11,331.21A0.46,0.46 0,0 1,338.57 330.76z",
    strokeWidth: 0,
    id: "path_3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0ebff",
    d: "m344.43,324.92h2.23c0.25,0 0.46,0.2 0.46,0.46v13.95c0,0.25 -0.2,0.46 -0.46,0.46h-2.23c-0.25,0 -0.46,-0.2 -0.46,-0.46v-13.95c0,-0.25 0.2,-0.46 0.46,-0.46Z",
    strokeWidth: 0,
    id: "path_4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0ebff",
    d: "m383.98,261.66h23.41c0.43,0 0.77,0.34 0.77,0.77v3.83c0,0.43 -0.34,0.77 -0.77,0.77h-23.41c-0.43,0 -0.77,-0.34 -0.77,-0.77v-3.83c0,-0.43 0.34,-0.77 0.77,-0.77Z",
    strokeWidth: 0,
    id: "path_5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0ebff",
    d: "m393.81,251.87h3.74c0.43,0 0.77,0.34 0.77,0.77v23.41c0,0.43 -0.34,0.77 -0.77,0.77h-3.74c-0.43,0 -0.77,-0.34 -0.77,-0.77v-23.41c0,-0.43 0.34,-0.77 0.77,-0.77Z",
    strokeWidth: 0,
    id: "path_6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0ebff",
    d: "M172.85,322.91L190.45,322.91A0.58,0.58 0,0 1,191.03 323.48L191.03,326.36A0.58,0.58 0,0 1,190.45 326.94L172.85,326.94A0.58,0.58 0,0 1,172.27 326.36L172.27,323.48A0.58,0.58 0,0 1,172.85 322.91z",
    strokeWidth: 0,
    id: "path_7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0ebff",
    d: "M180.24,315.55L183.06,315.55A0.58,0.58 0,0 1,183.63 316.13L183.63,333.72A0.58,0.58 0,0 1,183.06 334.3L180.24,334.3A0.58,0.58 0,0 1,179.66 333.72L179.66,316.13A0.58,0.58 0,0 1,180.24 315.55z",
    strokeWidth: 0,
    id: "path_8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0ebff",
    d: "m102.31,272.56h23.41c0.43,0 0.77,0.34 0.77,0.77v3.83c0,0.43 -0.34,0.77 -0.77,0.77h-23.41c-0.43,0 -0.77,-0.34 -0.77,-0.77v-3.83c0,-0.43 0.34,-0.77 0.77,-0.77Z",
    strokeWidth: 0,
    id: "path_9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0ebff",
    d: "M112.14,262.76L115.89,262.76A0.77,0.77 0,0 1,116.66 263.53L116.66,286.95A0.77,0.77 0,0 1,115.89 287.71L112.14,287.71A0.77,0.77 0,0 1,111.37 286.95L111.37,263.53A0.77,0.77 0,0 1,112.14 262.76z",
    strokeWidth: 0,
    id: "path_10"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0ebff",
    d: "M282.53,127.7L299.43,127.7A0.56,0.56 0,0 1,299.99 128.25L299.99,131.02A0.56,0.56 0,0 1,299.43 131.57L282.53,131.57A0.56,0.56 0,0 1,281.98 131.02L281.98,128.25A0.56,0.56 0,0 1,282.53 127.7z",
    strokeWidth: 0,
    id: "path_11"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0ebff",
    d: "M289.63,120.63L292.33,120.63A0.56,0.56 0,0 1,292.89 121.19L292.89,138.09A0.56,0.56 0,0 1,292.33 138.64L289.63,138.64A0.56,0.56 0,0 1,289.08 138.09L289.08,121.19A0.56,0.56 0,0 1,289.63 120.63z",
    strokeWidth: 0,
    id: "path_12"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#491826",
    d: "m230.01,120.06s-4.51,-8.91 -3.44,-16.22c1.07,-7.31 5.26,-11.41 15.42,-11.58 10.16,-0.18 21.39,1.69 24.42,4.63 3.03,2.94 2.05,6.86 2.05,6.86 0,0 3.3,0.54 4.37,4.81 1.07,4.28 -6.42,19.16 -6.42,19.16l-18.77,3.74 -17.62,-11.41Z",
    strokeWidth: 0,
    id: "path_13"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e3856",
    d: "M251.49,437.06l-27.53,0l-6.07,-176.89l41.08,-2.04l-7.48,178.93z",
    strokeWidth: 0,
    id: "path_14"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b497a",
    d: "M240.86,268.74l8.38,22.88l33.44,145.44l25.66,0l-23.64,-158l-0.95,-16.57l-42.9,6.26z",
    strokeWidth: 0,
    id: "path_15"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M247.63,287.24L244.66,437.06",
    stroke: "#385b8e",
    strokeWidth: 1,
    id: "path_16"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M278.87,299.61L301.69,437.06",
    stroke: "#4875aa",
    strokeWidth: 1,
    id: "path_17"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd8783",
    d: "m149.15,223.24l-11.04,-0.18s-3.72,-4.02 -6.55,-4.78 -7.21,-2.15 -7.3,-1.18c-0.09,0.97 0.09,2.04 2.65,3.22 2.56,1.18 4.56,4.18 4.56,4.18 0,0 -5.2,1.18 -9.31,0.64 -4.11,-0.54 -9.99,-2.17 -10.47,-1.29 -0.48,0.88 0.68,2.33 3.35,3.14 0,0 -5.27,-1.61 -5.75,-0.4s4.18,3.3 6.57,3.94c0,0 -5.13,-1.53 -5.48,-0.48 -0.34,1.05 3.9,3.7 6.71,4.02 0,0 -4.31,-1.37 -4.38,0 -0.07,1.37 6.02,4.26 10.88,5.23 4.86,0.97 9.38,0.97 12.52,0 3.15,-0.97 4.45,-1.37 4.45,-1.37l7.94,0.08s5.2,-9.5 0.63,-14.79Z",
    strokeWidth: 0,
    id: "path_18"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#cae0ef",
    d: "m161.46,251.07c-6.85,1.11 -10.34,2.76 -12.89,-8.36 -2.7,-11.76 -1.93,-21.69 -0.86,-22.76 0.34,-0.34 3.9,-0.77 8.69,-1.27 0,0 -0.32,19.85 5.06,32.39Z",
    strokeWidth: 0,
    id: "path_19"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m218.9,162.09v56.26s-1.18,1.5 -2.99,3.77c-2.57,3.22 -6.42,7.99 -9.94,12.17 -3.78,4.47 -7.18,8.28 -8.27,8.83 -2.85,1.42 -27.36,6.71 -35.02,7.77 -0.42,0.06 -0.83,0.12 -1.22,0.18 -5.38,-12.54 -5.06,-32.39 -5.06,-32.39 10.35,-1.08 26.43,-2.49 28.02,-4.08 2.32,-2.32 24.95,-41.08 28.78,-46.69 3.83,-5.61 5.7,-5.82 5.7,-5.82Z",
    strokeWidth: 0,
    id: "path_20"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m156.4,218.68s-0.32,19.85 5.06,32.39",
    stroke: "#b6cad8",
    strokeWidth: 1,
    id: "path_21"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#cae0ef",
    d: "m217.64,175l-1.73,47.12c-2.57,3.22 -6.42,7.99 -9.94,12.17l11.67,-59.29Z",
    strokeWidth: 0,
    id: "path_22"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "m264.62,268.74c-18.77,4.18 -33.98,0 -33.98,0l0.7,-8.57 8.39,-103.24 24.8,-0.51 0.08,103.79 0.01,8.53Z",
    strokeWidth: 0,
    id: "path_23"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd8783",
    d: "m264.55,131.93c-1.19,2.24 -2.74,4.03 -3.26,6.52 0,0 0,-0.03 0,0 -1.94,9.25 0.73,19.58 0.73,19.58l-15.49,6.63 -6.16,-6.08c0.36,-1.98 0.56,-3.65 0.64,-5.07 0.42,-7.29 -0.35,-8.93 -0.35,-8.93l11.56,-6.13 12.33,-6.53Z",
    strokeWidth: 0,
    id: "path_24"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea7171",
    d: "m260.94,138.46s0,-0.03 0,0c-0.31,0.93 -3.84,15.26 -13.53,17.15 -2.54,0.5 -4.65,-0.43 -6.39,-2.1 0.42,-7.29 -1.28,-9.48 -1.28,-9.48l12.49,-5.57h8.71Z",
    strokeWidth: 0,
    id: "path_25"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd8783",
    d: "m268,128.26c-0.46,4.14 -4.21,4.46 -4.21,4.46 -0.79,6.93 -4.43,10.24 -11.52,13.2 -7.09,2.97 -10.16,3.72 -16.07,-3.39 -2.06,-2.47 -3.43,-6.26 -4.35,-10.16 -1.73,-7.31 -1.84,-15 -1.84,-15l0.22,-6.44c7.36,6.13 20.66,4.88 20.66,4.88 -9.73,-0.46 -14.62,-4.61 -14.92,-4.87 8.87,3.29 19.75,1.25 19.75,1.25 1.44,6.44 6.62,6.79 6.62,6.79l0.79,7.29c1.06,-3.1 5.34,-2.15 4.87,1.99Z",
    strokeWidth: 0,
    id: "path_26"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5cd7b",
    d: "M240.91,154.45l6.49,7.63l13.86,-10.76l3.27,5.09l-9.36,15.95l-8.35,-7.13l-7.83,6.06l-0.24,-12.3l2.16,-4.54z",
    strokeWidth: 0,
    id: "path_27"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m294.16,303.19c-2.73,6.14 -32.12,5.81 -32.12,5.81 -4.36,-90.41 2.49,-152.58 2.49,-152.58 13.45,5.08 22.9,5.83 24.28,10.6 1.24,4.29 -3.84,51.29 -4.88,60.76 -0.11,1.07 -0.18,1.66 -0.18,1.66 0,0 9.67,49.73 10.7,67.76 0.17,3 0.1,5.12 -0.29,5.99Z",
    strokeWidth: 0,
    id: "path_28"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#cae0ef",
    d: "m345.54,254.58c-0.73,0.47 -5.57,0.18 -12,-0.51 -1.29,-20.95 4.91,-30.13 4.91,-30.13 5.57,1.02 9.88,1.92 10.62,2.43 2.34,1.6 -1.16,26.68 -3.53,28.21Z",
    strokeWidth: 0,
    id: "path_29"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m333.54,254.07c-14.52,-1.56 -37.16,-5.19 -39,-6.97 -2.66,-2.56 -15.49,-27.69 -15.67,-32.5 -0.17,-4.81 3.06,-48.5 6.34,-51.16 0,0 5.01,1.08 7.71,11.6 2.71,10.51 14.47,42.77 15.18,43.48 0.49,0.49 18.34,3.23 30.35,5.42 0,0 -6.2,9.18 -4.91,30.13Z",
    strokeWidth: 0,
    id: "path_30"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m239.73,156.93s-5.48,99.42 -4.2,153.66c0,0 -23.99,-3.23 -25.3,-7.4s5.4,-70.23 5.4,-70.23c0,0 1.58,-68.14 3.27,-70.87 1.02,-1.65 10.96,-1.65 20.83,-5.15Z",
    strokeWidth: 0,
    id: "path_31"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#b6cad8",
    d: "m347.47,240.28c-0.2,1.56 -0.44,3.05 -0.71,4.42 -0.99,4.97 -2.39,8.43 -3.49,8.3 -1.06,-0.13 -1.56,-3.52 -1.36,-8.25 0.06,-1.58 0.21,-3.31 0.43,-5.12 0.58,-4.66 1.58,-8.69 2.6,-10.9 0.54,-1.21 1.1,-1.88 1.6,-1.82 0.52,0.07 0.9,0.91 1.14,2.31 0.4,2.41 0.36,6.49 -0.21,11.06Z",
    strokeWidth: 0,
    id: "path_32"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd8783",
    d: "m373.8,237.07c1.41,-0.37 4.52,-1.09 4.79,-0.28 0.27,0.84 -2.4,2.71 -4.92,3.58 1.19,-0.23 2.55,-0.32 2.59,0.44 0.07,1.37 -6.02,4.27 -10.88,5.24 -4.86,0.96 -9.38,0.96 -12.53,0 -3.15,-0.97 -4.45,-1.37 -4.45,-1.37l-1.64,0.02 -4.85,0.05c0.06,-1.58 0.21,-3.31 0.43,-5.12 0.58,-4.66 1.58,-8.69 2.6,-10.9l2.74,0.49 3.19,0.57s3.71,-4.02 6.54,-4.77c2.83,-0.76 7.21,-2.15 7.3,-1.19 0.1,0.97 -0.09,2.04 -2.64,3.22 -2.56,1.18 -4.57,4.19 -4.57,4.19 0,0 5.21,1.18 9.31,0.64 4.11,-0.53 10,-2.17 10.47,-1.29 0.46,0.86 -0.6,2.24 -3.08,3.06 1.08,-0.31 5.07,-1.37 5.48,-0.32 0.44,1.1 -3.38,2.93 -5.88,3.74Z",
    strokeWidth: 0,
    id: "path_33"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "m338.45,223.94s-6.2,9.19 -4.91,30.13",
    stroke: "#b6cad8",
    strokeWidth: 1,
    id: "path_34"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#cae0ef",
    d: "m294.45,297.2l-21.81,-59.96 11.29,-56.5v47.04c-0.11,1.07 -0.18,1.66 -0.18,1.66 0,0 9.67,49.73 10.7,67.76Z",
    strokeWidth: 0,
    id: "path_35"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fffbfa",
    d: "m263.79,132.72c-0.79,6.93 -4.43,10.24 -11.52,13.2 -7.09,2.97 -10.16,3.72 -16.07,-3.39 -2.06,-2.47 -3.43,-6.26 -4.35,-10.16 0,0 7.16,-4.2 10.85,-4.38 3.68,-0.18 13.43,4.47 21.09,4.73Z",
    strokeWidth: 0,
    id: "path_36"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#cae0ef",
    d: "M264.53,156.42l10.07,19.51l-10.07,7.49l11.14,5.88l-15.08,42.06l18.27,-43.13l-9.14,-5.7l9.14,-6.95l-14.33,-19.15z",
    strokeWidth: 0,
    id: "path_37"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#cae0ef",
    d: "M239.73,156.93l-13.33,21.73l8.03,4.04l-9.54,7.25l11.59,42.17l-15,-42.53l8.52,-7.01l-7.21,-3.68l16.94,-21.97z",
    strokeWidth: 0,
    id: "path_38"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b271d",
    d: "m230.04,437.06s-5.18,7.62 -13.1,10.23c-7.93,2.62 -7.57,6.84 -7.57,6.84h37.66l-0.89,-17.08h-16.1Z",
    strokeWidth: 0,
    id: "path_39"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b271d",
    d: "m287.56,437.06s-2.57,7.73 -6.67,10.23c-6.87,4.19 -7,6.84 -7,6.84h32.08l-2.3,-17.08h-16.1Z",
    strokeWidth: 0,
    id: "path_40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDoctor);
export default __webpack_public_path__ + "static/media/no_doctor.08bb45b9994387398c5eb9ffdfd6aadd.svg";
export { ForwardRef as ReactComponent };